module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "subchapter"
  }, [_vm._v("Works Cited")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Brown, Alan. "), _c('em', [_vm._v("Ghost Hunters of the South.")]), _vm._v(" Jackson: University Press of Mississippi, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("———. "), _c('em', [_vm._v("Haunted Kentucky: Ghosts and Strange Phenomena of the Bluegrass State.")]), _vm._v(" Mechanicsburg, Pa.: Stackpole Books, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("———. "), _c('em', [_vm._v("Shadows and Cypress: Southern Ghost Stories.")]), _vm._v(" Jackson: University Press of Mississippi, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("McNeil, W. K. "), _c('em', [_vm._v("Ghost Stories from the American South.")]), _vm._v(" New York: Dell, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Montell, William Lynwood. "), _c('em', [_vm._v("Ghosts across Kentucky.")]), _vm._v(" Lexington: University Press of Kentucky, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("———. "), _c('em', [_vm._v("Ghosts along the Cumberland: Deathlore in the Kentucky Foothills.")]), _vm._v(" Knoxville: University of Tennessee Press, 1975.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("———. "), _c('em', [_vm._v("Haunted Houses and Family Ghosts of Kentucky.")]), _vm._v(" Lexington: University Press of Kentucky, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Walker, Barbara. "), _c('em', [_vm._v("Out of the Ordinary: Folklore and the Supernatural.")]), _vm._v(" Logan: Utah State University Press, 1995.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2724f396","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780813173894_epub_wc_r1.vue
// module id = 75
// module chunks = 0